import Icon from '../components/Icon.vue'

Icon.register({"houzz":{"width":1024,"height":1792,"paths":[{"d":"M512 1191l512-295v591l-512 296v-592zM0 896v591l512-296zM512 9v591l-512 296v-591zM512 600l512-295v591z"}]}})



//////////////////
// WEBPACK FOOTER
// ./~/vue-awesome/icons/houzz.js
// module id = FVk0
// module chunks = 1